import { Features } from '@backend/lib-feature-mgr';
import Image from 'next/image';
import { useMemo } from 'react';
import { styled } from 'styled-components';

import { getSocialMediaLinks } from '~/business/App/dto';
import { DownloadApp } from '~/components/DownloadApp';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useCheckFeatureEnabled, useTranslation } from '~/hooks';
import { getMediaQuery } from '~/utils/responsive/media';

const StyledFooterSocialMediaMenuWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${getMediaQuery('mobile')} {
    display: none;
  }
`;

const StyledFooterSocialMediaMenuRow = styled.div`
  display: flex;
  gap: 8px;
`;

const StyledFooterSocialMediaMenuItem = styled.a`
  width: 36px;
  height: 36px;
`;

const socialMediaNames = ['facebook', 'twitter', 'instagram', 'linkedin'] as const;

export const FooterSocialMenu = () => {
  const t = useTranslation();
  const { businessUnit } = useBusinessUnitContext();
  const links = useMemo(() => getSocialMediaLinks(businessUnit), [businessUnit]);
  const appToDownloadFeature = useCheckFeatureEnabled(Features.JobOfferAppToDownload);

  return (
    <StyledFooterSocialMediaMenuWrapper>
      {appToDownloadFeature && <DownloadApp />}
      <StyledFooterSocialMediaMenuRow>
        {socialMediaNames.map(socialMedia => {
          const title = t(`footer.socialMedia.${socialMedia}`);
          return (
            <StyledFooterSocialMediaMenuItem href={links[socialMedia]} target="_blank" title={title} key={socialMedia}>
              <Image src={`/images/icn-${socialMedia}.svg`} alt={title} width={36} height={36} />
            </StyledFooterSocialMediaMenuItem>
          );
        })}
      </StyledFooterSocialMediaMenuRow>
    </StyledFooterSocialMediaMenuWrapper>
  );
};
